module.exports = __webpack_public_path__ + "static/media/x.9b9b3b00.svg";